
import Vue from 'vue';
import Component from "vue-class-component";
import { namespace } from "vuex-class";
import { Prop, Watch } from "vue-property-decorator";
import { IShortCommunity } from "@/model/Community/communityInterfaces";

const communityModule = namespace("communityModule");

const ALL_COMMUNITIES_ID = 0;

@Component
export default class CommunitySearch extends Vue {
  @communityModule.Getter('communityList')
  private communities!: IShortCommunity[];

  @communityModule.Action('fetchAllCommunities')
  private fetchAllCommunities!: () => void;

  @Prop() value!: any;
  @Prop({default: false}) erasable!: boolean;
  @Prop({default: false}) disabled!: boolean;

  model!: number;

  private selectedId: number = 0;

  get isErasable(): boolean {
    return this.erasable !== false;
  }

  get communityItems() {
    const communities = this.communities || [];
    const ret: any = communities.map((community: IShortCommunity) => ({
      text: community.name + ' (#' + community.id + ')',
      value: community.id,
    }));
    ret.unshift({
      text: '-',
      value: ALL_COMMUNITIES_ID,
    });
    return ret;
  }

  @Watch('value')
  onValueChanged(newValue: number) {
    this.model = newValue;
  }

  created() {
    if (!this.communities || !this.communities.length) {
      this.fetchAllCommunities();
    }
    this.model = this.value;
  }

  onEraseClicked() {
    if (this.isErasable) {
      this.selectedId = ALL_COMMUNITIES_ID;
      this.$emit('onCommunitySelected', ALL_COMMUNITIES_ID);
    }
  }

  onCommunitySelected(newCommunityId: number) {
    if (!this.disabled) {
      this.$emit('onCommunitySelected', newCommunityId);
    }
  }
}
